import React, { Component } from "react";
import { Modal, Radio, Input, Space } from "antd";
import { StopOutlined } from "@ant-design/icons";
import "../cmms.css";

// Motivo por el que no se realizo un servicio calendarizado (lista de Configuracion + detalle).
// onAceptar(motivo)
class ModalNoRealizadoCMMS extends Component {
    state = { motivo: null, detalle: "", guardando: false };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) this.setState({ motivo: null, detalle: "", guardando: false });
    }

    aceptar = async () => {
        const texto = [this.state.motivo, this.state.detalle.trim()].filter(Boolean).join(": ");
        this.setState({ guardando: true });
        try {
            await this.props.onAceptar(texto);
        } finally {
            this.setState({ guardando: false });
        }
    };

    render() {
        const { visible, cantidad, motivos = [] } = this.props;
        const listo = !!this.state.motivo || !!this.state.detalle.trim();
        return (
            <Modal
                className="cmms-modal"
                visible={visible}
                onCancel={this.props.onCancel}
                onOk={this.aceptar}
                okText="Marcar no realizado"
                cancelText="Cancelar"
                okButtonProps={{ danger: true, disabled: !listo }}
                confirmLoading={this.state.guardando}
                width={window.innerWidth > 700 ? 480 : "96%"}
                title={
                    <div className="cmms-modal-titulo">
                        <StopOutlined style={{ fontSize: 20, color: "#d64545" }} />
                        <div>
                            <div className="cmms-modal-titulo-texto">No realizado</div>
                            <div className="cmms-modal-subtitulo">{cantidad > 1 ? `${cantidad} equipos. ` : ""}Queda en el progreso del contrato con su motivo.</div>
                        </div>
                    </div>
                }
            >
                <div className="cmms-modal-cuerpo" style={{ paddingBottom: 12 }}>
                    <Radio.Group value={this.state.motivo} onChange={(e) => this.setState({ motivo: e.target.value })}>
                        <Space direction="vertical">
                            {motivos.map((m) => (
                                <Radio key={m} value={m}>
                                    {m}
                                </Radio>
                            ))}
                        </Space>
                    </Radio.Group>
                    <Input.TextArea
                        style={{ marginTop: 10 }}
                        rows={2}
                        maxLength={250}
                        placeholder="Detalle (opcional)"
                        value={this.state.detalle}
                        onChange={(e) => this.setState({ detalle: e.target.value })}
                    />
                </div>
            </Modal>
        );
    }
}

export default ModalNoRealizadoCMMS;
